import { render, staticRenderFns } from "./InvestmentHistoryModal.vue?vue&type=template&id=ec734f30&scoped=true"
import script from "./InvestmentHistoryModal.vue?vue&type=script&lang=js"
export * from "./InvestmentHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./InvestmentHistoryModal.vue?vue&type=style&index=0&id=ec734f30&prod&scoped=true&lang=css"
import style1 from "./InvestmentHistoryModal.vue?vue&type=style&index=1&id=ec734f30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec734f30",
  null
  
)

export default component.exports